// @ts-nocheck
import * as React from "react";
import anime from "animejs/lib/anime.es.js";

// Components
import Loader from "../Loader";
import Banner from "../Banner";
import ModalInfo from "../modalInfo";

const THEMEURL = window.drupalSettings ? window.drupalSettings.path.themeUrl : 'themes/custom/mx_aguas_firmes_theme';

const elementList = [
    <img className='af-bg-aditional__cloud' src={`/${THEMEURL}/sources/dist/assets/images/general/background/cielo/nube1.png`} alt="" title="" />,
    <img className='af-bg-aditional__cloud2' src={`/${THEMEURL}/sources/dist/assets/images/general/background/cielo/nube3.png`} alt="" title="" />,
]

export const Register = ({ data, setLoading, loading }: any) => {
    const [visibleForm, setVisibleForm] = React.useState<any>(false)
    //const [isMayor, setIsMayor] = React.useState<any>(false)

    React.useEffect(() => {
        window.onload = function () {
            setLoading(false)
        }
    }, []);

    const animateSky = () => {
        anime({
            targets: '.af-bg-aditional__cloud',
            translateX: 100,
            loop: true,
            easing: 'linear',
            direction: 'alternate',
            duration: 20000,
        })

        anime({
            targets: '.af-bg-aditional__cloud2',
            translateX: -50,
            loop: true,
            easing: 'linear',
            direction: 'alternate',
            duration: 10000,
        })
    }

    const selectOption = (e) => {
        if(isMayor){
            //setVisibleForm(true)
        }else{
            //window.location.href = '/galeria';
        }
    }

    const clickBtnYes = () => {
        document.getElementById('si').classList.add('selectedBtn');
        document.getElementById('no').classList.remove('selectedBtn');
        setVisibleForm(true)
    }

    const clickBtnNo = () => {
        document.getElementById('si').classList.remove('selectedBtn');
        document.getElementById('no').classList.add('selectedBtn');
        window.location.href = '/galeria';
    }

    React.useEffect(() => {
        animateSky()
    })

    return (
        <main>
            <div className='boxAllies'>
                <Banner
                    backImage={{ desk: `/${THEMEURL}/sources/dist/assets/images/register/banner.jpg`, mobile: `/${THEMEURL}/sources/dist/assets/contact/contactoMobile.jpg` }}
                    textBanner={!loading ? data.field_title : ''}
                    textDescription={data.field_desc}
                    componentsAnimated={elementList}
                    newBanner={1}
                />
            </div>
            <div className="background-contact">

                <div id="newFormRegisterEdad" className={`form ${visibleForm ? '' : 'formVisible'}`} data-aos="fade-up" data-aos-duration="1000" data-aos-anchor-placement='top-bottom'>
                    <h2 className="form__title">1. CONFIRMACIÓN DE EDAD</h2>
                    <h5 className="form__subtitle">¿Eres mayor de edad?*</h5>
                    <div className="form__containerBtns">
                        <button id="si" className={`form__containerBtns--Si`} onClick={clickBtnYes}>SI</button>
                        <button id="no" className={`form__containerBtns--No`}  onClick={clickBtnNo}>NO</button>
                    </div>
                </div>

                {/*Formulario registro*/}
                <div id="newFormRegister" className={`form ${visibleForm ? 'formVisible' : ''}`} data-aos-anchor-placement='top-bottom'>
                    <h2 className="form__title">2. DATOS PERSONALES</h2>
                </div>


            </div>
        </main>
    )
}

export default Loader(Register)